import { api } from './api';

export const adminRatesService = {
  async getAllPlans(): Promise<any> {
    const res = await api.get('/admin/plans');
    return res.data;
  },

  async getPlanRates(planId: string | number): Promise<any> {
    const res = await api.get(`/admin/plans/${planId}/rates`);
    return res.data;
  },

  async createPlan(payload: { name: string }): Promise<any> {
    const res = await api.post('/admin/plans', payload);
    return res.data;
  },

  async saveAsNewPlan(payload: { name: string, rates: any[] }): Promise<any> {
    const res = await api.post(`/admin/plans/save-as-new`, payload);
    return res.data;
  },

  async updatePlanRates(planId: string | number, payload: { name?: string, rates: any[] }): Promise<any> {
    const res = await api.put(`/admin/plans/${planId}`, payload);
    return res.data;
  },

  async updateRate(planId: string | number, rateId: string | number, payload: any): Promise<any> {
    const res = await api.put(`/admin/plans/${planId}/rates/${rateId}`, payload);
    return res.data;
  },

  async uploadRates(planName: string, file: File): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('planName', planName);
    const res = await api.post(`/admin/plans/rates/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },

  async uploadAndReplaceRates(planId: string | number, file: File): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);
    const res = await api.post(`/admin/plans/${planId}/rates/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },

  async downloadSampleRates(planId?: string | number): Promise<Blob> {
    const url = planId ? `/admin/plans/${planId}/rates/download-sample` : `/admin/plans/rates/download-sample`;
    const res = await api.get(url, { responseType: 'blob' });
    return res.data;
  },

  async downloadUserRates(userId: string | number): Promise<Blob> {
    const res = await api.get(`/admin/manage-users/${userId}/rates/download`, { responseType: 'blob' });
    return res.data;
  },

  async changeUserPlan(userId: string | number, planId: string | number, planType?: string): Promise<any> {
    const res = await api.patch(`/admin/manage-users/${userId}/plan`, { planId, planType });
    return res.data;
  },

  async changeUserB2bPlan(userId: string | number, b2bPlanId: string | number): Promise<any> {
    const res = await api.patch(`/admin/manage-users/${userId}/plan`, { planId: b2bPlanId, b2bPlanId, planType: 'b2b' });
    return res.data;
  }
};
